module.exports = __webpack_public_path__ + "img/image_012.c89b0e01.jpg";